import React, { FC } from 'react'

export const VerifiedBadge: FC = () => (
  <span aria-label="Phone verified" className="user-profile-login__verified" role="img">
    <svg aria-hidden="true" className="user-profile-login__verified-icon" fill="none" viewBox="0 0 20 20">
      <g className="user-profile-login__verified-circle">
        <circle cx="10" cy="10" r="8.5" />
      </g>
      <g className="user-profile-login__verified-check">
        <path d="M6.2 10.4 8.8 13 13.8 8" />
      </g>
    </svg>
  </span>
)
